import React from 'react';
import { Group, rem } from '@mantine/core';
import { Link } from 'react-router-dom';
import BrandTile from '@/components/brand/Brand.Tile';
import BrandWordmark from '@/components/brand/Brand.Wordmark';

type Props = {
    compact?: boolean;
};

const ShellLogo: React.FC<Props> = ({ compact = false }) => (
    <Group
        component={Link}
        gap={0}
        wrap="nowrap"
        aria-label="BeSuites, vai alla panoramica"
        style={{ textDecoration: 'none', color: 'inherit', flexShrink: 0, minHeight: rem(44), minWidth: rem(44), alignItems: 'center', justifyContent: compact ? 'center' : 'flex-start' }}
        {...({ to: '/overview' } as object)}
    >
        {compact ? <BrandTile size={32} /> : <BrandWordmark height={22} />}
    </Group>
);

export default ShellLogo;
